module.exports = __webpack_public_path__ + "images/stickers/huh@2x.2f9059c46976ae30316a.png";